import { validateEmail } from '@oolio-group/design-common';
import React, { useMemo, useState } from 'react';
import { TextInput, View } from 'react-native';
import type { InputEmailProps } from './Input.types';
import { getStyles, noFocusOutline } from './Input.styles';
import { useTheme } from '../../hooks/useTheme';
import Icon from '../Icon/Icon';

export const InputEmail: React.FC<InputEmailProps> = ({
  containerStyles,
  value,
  onFocus,
  onBlur,
  ...props
}) => {
  const { colors } = useTheme();
  const styles = useMemo(() => getStyles(colors), [colors]);

  const [isFocused, setIsFocused] = useState(false);

  const hasValue = !!value && String(value).length > 0;
  const isValid = hasValue && validateEmail(String(value));

  return (
    <View
      style={[
        styles.container,
        isFocused && styles.containerFocused,
        containerStyles,
      ]}
    >
      <TextInput
        placeholder="Enter email address..."
        {...props}
        value={value}
        keyboardType="email-address"
        autoCapitalize="none"
        autoComplete="email"
        autoCorrect={false}
        placeholderTextColor={colors.placeholder}
        style={[styles.inner, noFocusOutline]}
        onFocus={e => {
          setIsFocused(true);
          onFocus?.(e);
        }}
        onBlur={e => {
          setIsFocused(false);
          onBlur?.(e);
        }}
      />
      {hasValue && (
        <View style={styles.accessory}>
          <Icon
            size={26}
            name={isValid ? 'check' : 'exclamation-triangle'}
            color={isValid ? colors.positive : colors.negative}
          />
        </View>
      )}
    </View>
  );
};
